import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { KeyValuePairEnum } from '../../models/key-value-pair-enum';

@Injectable({ providedIn: 'root' })
export class CFSignatureStoreService {
    private signatureTypesSource = new ReplaySubject<Array<KeyValuePairEnum>>(1);
    public signatureTypes$ = this.signatureTypesSource.asObservable();

    public selectedSectionId!: string;
    public selectedSignerId!: string;
    public selectedSignatureType!: number;
    public signatureId!: string;

    constructor() {
        this.resetFilters();
    }

    public setSignatureTypes(signatureTypes: Array<KeyValuePairEnum>): void {
        this.signatureTypesSource.next(signatureTypes);
    }

    public resetFilters(): void {
        this.selectedSectionId = '';
        this.selectedSignerId = '';
        this.selectedSignatureType = 0;
        this.signatureId = '';
    }

    public areFiltersValid(): boolean {
        return this.selectedSignatureType !== undefined &&
            this.selectedSectionId &&
            this.selectedSectionId !== '' &&
            this.selectedSignerId &&
            this.selectedSignerId !== ''
            ? true
            : false;
    }
}
